__turbopack_context__.v({
  "controls": "KulR-W_controls",
  "mobileCloseButton": "KulR-W_mobileCloseButton",
  "primaryButton": "KulR-W_primaryButton",
  "root": "KulR-W_root",
  "secondaryButton": "KulR-W_secondaryButton",
  "title": "KulR-W_title",
  "visible": "KulR-W_visible",
});
